import { useState } from "react";
import Currencies from "../components/Currencies";
import Coins from "../components/Coins";
import Sidebar from "../components/Sidebar";

const MainPage = ({currencies, coins, isLoading}) => {

  const [showSidebar, setShowSidebar] = useState(false);

  return (
    <div className="main-page">
      <Currencies currencies={currencies} isLoading={isLoading} />
      <hr />
      <Coins coins={coins} isLoading={isLoading} />
      <Sidebar
        currencies={currencies}
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
      />
    </div>
  );
};
export default MainPage;
